"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowNumericEditor_1 = require("../../../../shared/components/editors/CardRowNumericEditor");
var CardRowTextEditor_1 = require("../../../../shared/components/editors/CardRowTextEditor");
var CardRowSelectEditor_1 = require("../../../../shared/components/editors/CardRowSelectEditor");
var CardRowCheckBoxEditor_1 = require("../../../../shared/components/editors/CardRowCheckBoxEditor");
var DlgGeneratePromoCodeOperation = /** @class */ (function (_super) {
    __extends(DlgGeneratePromoCodeOperation, _super);
    function DlgGeneratePromoCodeOperation(props) {
        var _this = _super.call(this, props) || this;
        _this.SID_PP = 0;
        _this.SID_PP_P = 0;
        _this.SID_PP_O = 0;
        return _this;
    }
    DlgGeneratePromoCodeOperation.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                dialogTitle: data.title,
                promoTypeTitle: data.promo_type_title
            }, function () {
                if (_this.state.visible) {
                    _this.props.listAffilatesAvail.LoadData();
                }
            });
        });
        this.setState({
            visible: this.props.controller.DATA.visible,
            dialogTitle: this.props.controller.DATA.title,
            promoTypeTitle: this.props.controller.DATA.promo_type_title,
            count: 10,
            description: "",
            is_bind_partner: false,
            pprogram_id: 0,
            pprogram_title: "",
            pprograms_avail: [],
            offer_id: 0,
            offer_title: "",
            offers_avail: [],
            partner_id: 0,
            partner_login: "",
            partners_avail: []
        });
        this.doReSetRules();
        this.SID_PP = this.props.listAffilatesAvail.Subscribe("*", function (id, data) {
            _this.setState({
                pprograms_avail: data.data,
                pprogram_id: 0,
                pprogram_title: "",
                offer_id: 0,
                offer_title: "",
                offers_avail: [],
                partner_id: 0,
                partner_login: "",
                partners_avail: []
            });
        });
        this.SID_PP_P = this.props.listAffilatesPartnersAvail.Subscribe("*", function (id, data) {
            _this.setState({
                offer_id: 0,
                offer_title: "",
                offers_avail: [],
                partner_id: 0,
                partner_login: "",
                partners_avail: data.data
            });
        });
        this.SID_PP_O = this.props.listAffilatesPartnersOffersAvail.Subscribe("*", function (id, data) {
            _this.setState({
                offer_id: 0,
                offer_title: "",
                offers_avail: data.data
            });
        });
    };
    DlgGeneratePromoCodeOperation.prototype.doReSetRules = function () {
        this.setState({
            count_rules: { isError: false },
            pprogram_rules: { isError: false },
            offer_rules: { isError: false },
            partner_rules: { isError: false }
        });
    };
    DlgGeneratePromoCodeOperation.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
        this.props.listAffilatesAvail.UnSubscribe(this.SID_PP);
        this.props.listAffilatesPartnersAvail.UnSubscribe(this.SID_PP_P);
        this.props.listAffilatesPartnersOffersAvail.UnSubscribe(this.SID_PP_O);
    };
    DlgGeneratePromoCodeOperation.prototype.isDataValid = function () {
        this.doReSetRules();
        if (this.state.count < 0) {
            this.setState({ count_rules: { isError: true, errorMessage: "Поле [количество] слишком мало!" } });
            return false;
        }
        if (this.state.count > 999) {
            this.setState({ count_rules: { isError: true, errorMessage: "Поле [количество] слишком велико!" } });
            return false;
        }
        if (isNaN(this.state.count)) {
            this.setState({ count_rules: { isError: true, errorMessage: "Поле [количество] некорректно!" } });
            return false;
        }
        if (this.state.is_bind_partner) {
            if (this.state.pprogram_id <= 0) {
                this.setState({
                    pprogram_rules: {
                        isError: true,
                        errorMessage: "Поле [П.Программа] не заполнено!"
                    },
                });
                return false;
            }
            if (this.state.offer_id <= 0) {
                this.setState({
                    offer_rules: {
                        isError: true,
                        errorMessage: "Поле [Оффер] не заполнено!"
                    },
                });
                return false;
            }
            if (this.state.partner_id <= 0) {
                this.setState({
                    partner_rules: {
                        isError: true,
                        errorMessage: "Поле [Партнер] не заполнено!"
                    },
                });
                return false;
            }
        }
        return true;
    };
    DlgGeneratePromoCodeOperation.prototype.handleYes = function () {
        if (this.isDataValid()) {
            this.props.controller.Close();
            if (this.props.controller.DATA.onYes) {
                this.props.controller.DATA.onYes(this.state.count, this.state.description, this.state.is_bind_partner, this.state.pprogram_id, this.state.partner_id, this.state.offer_id);
            }
        }
    };
    DlgGeneratePromoCodeOperation.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgGeneratePromoCodeOperation.prototype.OnCountChanged = function (value) {
        this.setState({ count: value });
    };
    DlgGeneratePromoCodeOperation.prototype.OnDescriptionChanged = function (newValue) {
        this.setState({ description: newValue });
    };
    DlgGeneratePromoCodeOperation.prototype.render = function () {
        var _this = this;
        return React.createElement(antd_1.Modal, { title: this.state.dialogTitle, visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: false, maskClosable: false, okType: "primary", style: { minWidth: 600 } },
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", } },
                React.createElement(CardRowTextEditor_1.default, { disabled: true, texts: { caption: "Тип промокода", placeholder: "Тип промокода" }, value: this.state.promoTypeTitle, onValueChanged: null }),
                React.createElement(CardRowNumericEditor_1.default, { onValueChanged: this.OnCountChanged.bind(this), texts: { caption: "Количество кодов:", placeholder: "Введите количество кодов" }, values: { min: 1, max: 999, value: this.state.count } }),
                React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Комментарий операции", placeholder: "Введите комментарий" }, onValueChanged: this.OnDescriptionChanged.bind(this), value: this.state.description }),
                React.createElement(CardRowCheckBoxEditor_1.default, { title: "Привязать партнера", value: this.state.is_bind_partner, onChecked: function (checked) { _this.setState({ is_bind_partner: checked }); } }),
                React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "П.Программа:", placeholder: "Выберите партнерскую программу" }, value: { key: this.state.pprogram_id, value: this.state.pprogram_title }, onValueChanged: function (newVal) {
                        _this.setState({
                            pprogram_id: newVal.key,
                            pprogram_title: newVal.value,
                            pprogram_rules: { isError: false }
                        }, function () {
                            _this.props.listAffilatesPartnersAvail.LoadData(_this.state.pprogram_id);
                            //this.props.controller.SetPProgramId(this.state.pprogram_id);
                            //this.props.controller.SetPProgramTitle(this.state.pprogram_title);
                        });
                    }, items: this.state.pprograms_avail, required: true, rules: this.state.pprogram_rules, disabled: !this.state.is_bind_partner }),
                React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Партнер :", placeholder: "Выберите партнера" }, value: { key: this.state.partner_id, value: this.state.partner_login }, onValueChanged: function (newVal) {
                        _this.setState({
                            partner_id: newVal.key,
                            partner_login: newVal.value,
                            partner_rules: { isError: false }
                        }, function () {
                            _this.props.listAffilatesPartnersOffersAvail.LoadDataKeysAreUsrPartnerOfferId(_this.state.partner_id);
                        });
                    }, items: this.state.partners_avail, required: true, rules: this.state.partner_rules, disabled: !this.state.is_bind_partner }),
                React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Оффер:", placeholder: "Выберите значение оффера" }, value: { key: this.state.offer_id, value: this.state.offer_title }, onValueChanged: function (newVal) {
                        _this.setState({
                            offer_id: newVal.key,
                            offer_title: newVal.value,
                            offer_rules: { isError: false }
                        }, function () {
                            //this.props.controller.SetDnmVal(this.state.dnm_val);
                        });
                    }, items: this.state.offers_avail, required: true, rules: this.state.offer_rules, disabled: !this.state.is_bind_partner, floatKey: true })));
    };
    return DlgGeneratePromoCodeOperation;
}(React.Component));
exports.default = DlgGeneratePromoCodeOperation;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/DlgGeneratePromoCodeOperation.tsx
// module id = 2048
// module chunks = 0